import {mapDepartmentHealthResponse} from '../serializers/DepartmentHealthSerializers';
import type {DepartmentHealthDetail} from '../types/DepartmentHealthTypes';

import {useApiRead} from '../../../../hooks/useApiRead';
import {GetRoutes} from '../../../../lib/api/GET/GetRoutes';

interface DepartmentHealthDetailState {
  data: DepartmentHealthDetail | null;
  isLoading: boolean;
  error: unknown;
}

export const useDepartmentHealthDetail = (
  companyId: string,
  departmentId: string | null,
): DepartmentHealthDetailState => {
  const path = departmentId ? GetRoutes.companyDepartmentHealth(companyId, departmentId) : '';

  const result = useApiRead<DepartmentHealthDetail>({
    path,
    camelCaseOverride: mapDepartmentHealthResponse,
    options: {
      enabled: !!companyId && !!departmentId,
      queryKey: ['departmentHealth', companyId, departmentId],
    },
  });

  return {
    data: result.data ?? null,
    isLoading: result.isLoading,
    error: result.error,
  };
};
